module.exports = __webpack_public_path__ + "static/ampersand-b9f7270504c3faca88d8da3f7164c11f.png";